import { render, staticRenderFns } from "./OverlayPastOrders.vue?vue&type=template&id=62ad39f3"
import script from "./OverlayPastOrders.vue?vue&type=script&lang=js"
export * from "./OverlayPastOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports